module.exports = __webpack_public_path__ + "img/banner15.d0fd2b70.jpg";